// Distinguishes the two admin-managed method lists. Maps to the URL segment
// used by the payment API (`payment-methods` / `payout-methods`).
export enum ManagedMethodKind {
  deposit = 'deposit',
  payout = 'payout',
}

// Item from GET /admin/payment-methods and GET /admin/payout-methods.
export interface ManagedMethod {
  id: string;
  name: string;
  currency: string;
  provider: string;
  tokenCode: string;
  enabled: boolean;
  // Higher value shows first in the storefront method list.
  sortOrder: number;
  country: string | null;
}
